angular.module('SpidApp')

.controller('StocksController', 
		['$scope', 'StockService', 'Stock', 'StockFlowService', 'StockFlow', 'AgencyService', 'RouteSupervisor', '$stateParams', 'ProductService', 'OperationalProductService', 'StockManager', 'Toaster', '$timeout',    
function ($scope,   StockService,   Stock,   StockFlowService,   StockFlow,   AgencyService,   RouteSupervisor,   $stateParams,   ProductService,   OperationalProductService,   StockManager,   Toaster,   $timeout) {
    
	if (!$stateParams.agencyId) {
        throw 'StocksController() - You should provide an agency id'
    }
    
    var agencyId = $stateParams.agencyId
    $scope.form = {};
    
    var fetchAgencies = function () {
		return AgencyService.all().then(function(agencies) {
			if (!agencies) {
				return;
			}
			
			$scope.agencies = agencies;
			
			if (agencyId === 0) {
				agencyId = $scope.agencies[0].id
			}
			
			$scope.groupedAgencies = _.indexBy($scope.agencies, function (agency) {
				return agency.id
			})
			
			$scope.form.selectedAgency = $scope.groupedAgencies[agencyId]
			$scope.form.selectedAgencyId = ''+agencyId;
		});
	}
    
    
    var fetchStocks = function () {
		return StockService.findByAgencyId(agencyId).then(function (stocks) {
	        $scope.stocks = stocks;
		});
	}
    
    var getStockProducts = function() {
    	return ProductService.all().then(function (products) {
	    	$scope.stockProducts = _.chain(StockManager.agregateProductAndStock(products, $scope.stocks)).sortBy(function (stockProduct) {
	            return stockProduct.product.category;
	        }).value();
	    })
    }
    
    var getStockProductsOp = function() {
    	return OperationalProductService.all().then(function (operationalProducts) {
        	$scope.stockOpProducts = _.chain(StockManager.agregateProductAndStock(operationalProducts, $scope.stocks)).sortBy(function (stockProduct) {
                return stockProduct.product.category;
            }).value();
    	})
    }
    
    var fetchStockProducts = function() {
    	return fetchStocks().then(function () {
	        return getStockProducts();
	    });
    }
    
    var fetchStockProductsOp = function() {
    	return fetchStocks().then(function () {
	        return getStockProductsOp();
	    });
    }
    
    var reloadStocks = function() {
	    fetchStocks().then(function () {
	        return getStockProducts();
	    }).then(function () {
	    	return getStockProductsOp();
	    });
    }
    
    fetchAgencies().then(function(){
    	reloadStocks();
    });
    
    var _resetStockProduct = function(stockProduct) {
    	if (!stockProduct) {
    		return false;
    	}
    	
		stockProduct.quantity = stockProduct.quantity || 0;
		if (stockProduct.quantity !== stockProduct.qtyOrigine) {
			stockProduct.quantity = stockProduct.qtyOrigine;
		}
		return true;
    }
    
    $scope.resetStockProduct = function(stockProduct) {
    	if (_resetStockProduct(stockProduct)) {
    		Toaster.show('La valeur de stock pour <b>' + stockProduct.product.label + '</b> a été réinitialisée')
    	}
    	else {
    		fetchStockProducts().then(function() {
				Toaster.show('Les valeurs de stock pour les produits de vente ont été réinitialisées')
			})
    	}
    }
    
    $scope.resetStockProductOp = function(stockProduct) {
    	if (_resetStockProduct(stockProduct)) {
			Toaster.show('La valeur de stock pour <b>'+stockProduct.product.label+'</b> a été réinitialisée')
    	}
    	else {
    		fetchStockProductsOp().then(function() {
				Toaster.show('Les valeurs de stock pour les produits de fonctionnement ont été réinitialisées')
			})
    	}
    }
    
    $scope.saveStockProduct = function(stockProduct) {
    	if (stockProduct) {
    		StockManager.saveStockProduct(stockProduct, agencyId).then(function() {
    			Toaster.show('La valeur de stock pour <b>' + stockProduct.product.label + '</b> a été sauvegardée')
    		});
    	}
    	else {
    		StockManager.saveStockProducts($scope.stockProducts, agencyId).then(function() {
    			return fetchStockProducts();
			}).then(function() {
    			Toaster.show('Les valeurs de stock pour les produits de vente ont été sauvegardées')
    		});
    	}
    }
    
    $scope.saveStockProductOp = function(stockProduct) {
    	if (stockProduct) {
    		StockManager.saveStockProduct(stockProduct, agencyId).then(function() {
    			Toaster.show('La valeur de stock pour <b>' + stockProduct.product.label + '</b> a été sauvegardée')
    		});
    	}
    	else {
    		StockManager.saveStockProducts($scope.stockOpProducts, agencyId).then(function() {
    			return fetchStockProductsOp();
			}).then(function() {
				Toaster.show('Les valeurs de stock pour les produits de fonctionnement ont été sauvegardées')
    		});
    	}
    }
    
    $scope.printProduct = function() {
		$scope.dateNow = moment(new Date()).format('LLL');
		
		fetchStockProducts().then(function() {
	    	$timeout(function() {
	    		window.print();
	    	}, 50);
		});
	}
    
    $scope.printProductOp = function() {
		$scope.dateNow = moment(new Date()).format('LLL');
		
		fetchStockProductsOp().then(function() {
	    	$timeout(function() {
	    		window.print();
	    	}, 50);
		});
    }
    
    $scope.isWarningShow = function(stockProduct) {
    	if (!stockProduct.quantity && stockProduct.qtyOrigine === 0) {
    		return false;
    	}
    	return stockProduct.quantity !== stockProduct.qtyOrigine
    }
    
    $scope.changeAgency = function() {
    	if (!$scope.form.selectedAgencyId) {
    		return;
    	}
    	agencyId = $scope.form.selectedAgencyId;
    	$scope.form.selectedAgency =  $scope.groupedAgencies[agencyId]
    	
    	reloadStocks();
    	
    	$scope.$broadcast('changeAgencyEvent', {'agencyId':$scope.form.selectedAgency.id}); 
    }
    
    $scope.$on('changeRoleEvent', function(event, args) {
    	RouteSupervisor.bounce(event, args.role);
    });

}])
